// extracted by mini-css-extract-plugin
export default {"panel":"styles_panel__0m-j+","divider":"styles_divider__NwKeq"};